"use client";

import { c as _c } from "react/compiler-runtime";
import type { PropsWithChildren } from "react";
import { EmsNotEntitledPage } from "@/components/EmsNotEntitledPage/EmsNotEntitledPage";
import { useAbility } from "@/hooks/useAbility";
import { useOrganization } from "@/hooks/useOrganization";
import { useEmsEntitlementGate } from "./hooks/useEmsEntitlementGate/useEmsEntitlementGate";
export function EmsEntitlementGate(t0) {
  const $ = _c(5);
  const {
    children
  } = t0;
  const {
    currentEntitlement
  } = useOrganization();
  const {
    can
  } = useAbility();
  const isSystemAdmin = can("manage", {
    scopeType: "SYSTEM"
  });
  const {
    handleOrganizationSelected,
    isSwitchingOrganization,
    organizationSwitchError
  } = useEmsEntitlementGate();
  const isBlocked = currentEntitlement?.status === "not_entitled" && !isSystemAdmin;
  if (isBlocked || isSwitchingOrganization) {
    let t1;
    if ($[0] !== handleOrganizationSelected || $[1] !== organizationSwitchError) {
      t1 = <EmsNotEntitledPage onOrganizationSelected={handleOrganizationSelected} organizationSwitchError={organizationSwitchError} />;
      $[0] = handleOrganizationSelected;
      $[1] = organizationSwitchError;
      $[2] = t1;
    } else {
      t1 = $[2];
    }
    return t1;
  }
  let t1;
  if ($[3] !== children) {
    t1 = <>{children}</>;
    $[3] = children;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  return t1;
}